<div class="container-fluid complyon-page continuity-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell continuity-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title continuity-title mb-2 text-l">Business continuity & DR</h1>
      <p class="complyon-subtitle continuity-subtitle mb-0 text-s">The plans that keep the organisation running through disruption - critical processes, recovery objectives, supplier failover and DR test evidence.</p>
    </section>

    <section class="row g-3 mb-3">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
        <article class="complyon-card rounded-4 p-3 h-100">
          <div class="complyon-stat-label text-xs">{{ card.label }}</div>
          <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : card.accent === 'green' ? 'text-success' : 'text-dark'">{{ card.value }}</div>
          <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
        </article>
      </div>
    </section>

    <section class="complyon-panel rounded-4 overflow-hidden">
      <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
        <div>
          <div class="complyon-section-title text-s">Business continuity & disaster recovery</div>
          <div class="complyon-section-subtitle text-xs">The plans that keep the organisation running through disruption - critical processes, recovery time objectives, critical-supplier failover and the DR test evidence that proves each plan actually works.</div>
        </div>
        <button type="button" class="btn config-navbar-primary-action finance-action-btn">
          <i class="bi bi-plus-lg"></i>
          <span>New plan</span>
        </button>
      </div>

      <div class="px-3 pb-2 pt-2 d-flex flex-wrap align-items-center justify-content-between gap-2 border-top border-light-subtle">
        <div class="d-flex flex-wrap align-items-center gap-1">
          <button v-for="filter in filters" :key="filter.label" type="button" class="btn doa-tab-btn fw-semibold" :class="{ active: filter.active }">
            <span>{{ filter.label }}</span>
          </button>
        </div>
        <div class="input-group" style="max-width: 170px;">
          <span class="input-group-text bg-white"><i class="bi bi-search text-secondary"></i></span>
          <input type="search" class="form-control" placeholder="Search..." aria-label="Search plans">
        </div>
      </div>

      <div class="table-responsive">
        <table class="table complyon-table align-middle mb-0">
          <thead>
            <tr>
              <th class="ps-3 text-xs">Ref</th>
              <th class="text-xs">Plan</th>
              <th class="text-xs">Critical process</th>
              <th class="text-xs">RTO</th>
              <th class="text-xs">RPO</th>
              <th class="text-xs">Last test</th>
              <th class="text-xs">Status</th>
              <th class="pe-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.ref">
              <td class="ps-3 fw-semibold text-success">{{ row.ref }}</td>
              <td class="fw-semibold">{{ row.plan }}</td>
              <td>{{ row.process }}</td>
              <td>{{ row.rto }}</td>
              <td>{{ row.rpo }}</td>
              <td>{{ row.last_test }}</td>
              <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
              <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</div>
